import React, { memo, useMemo } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Field } from 'react-final-form';
import { Row, Col } from 'antd';

import {
    LabelInput,
    LabelColorPicker,
    LabelUserMultiSelect,
} from 'components/Shared/Forms';
import { composeValidators } from 'utils/formValidator';

const formatMessages = intl => ({
    labelGroupName: intl.formatMessage({
        id: 'smallDrawer.feed.information.title.label',
        defaultMessage: 'Nom du groupe'
    }),
    errorGroupName: intl.formatMessage({
        id: 'smallDrawer.feed.information.title.errorMessage',
        defaultMessage: 'Ce champs doit comporter 1 caractères minimum'
    }),
    tooltipGroupName: intl.formatMessage({
        id: 'smallDrawer.feed.information.color.tooltip',
        defaultMessage: 'Couleur du groupe'
    }),
    labelDescription: intl.formatMessage({
        id: 'smallDrawer.feed.information.description.title',
        defaultMessage: 'Description du groupe'
    }),
    namePlaceholder: intl.formatMessage({
        id: 'smallDrawer.feed.information.name.placeholder',
        defaultMessage: 'Entrer un nom'
    }),
    descriptionPlaceholder: intl.formatMessage({
        id: 'smallDrawer.feed.information.description.placeholder',
        defaultMessage: 'Entrer une description'
    }),
    labelColor: intl.formatMessage({
        id: 'drawer.colorPicker.label',
        defaultMessage: 'Couleur'
    }),
    multiSelectNoOptionsText: intl.formatMessage({
        id: 'drawer.createGroup.multiSelect.noOptionsMessageText',
        defaultMessage: 'Pas de relations trouvés.'
    }),
    multiSelectPlaceholder: intl.formatMessage({
        id: 'drawer.createGroup.multiSelect.placeholder',
        defaultMessage: 'Un de vos contacts'
    }),
    sendInvitations: intl.formatMessage({
        id: 'drawer.createGroup.sendInvitations',
        defaultMessage: 'Envoyer des invitations à'
    }),
});

const inputXLargeStyle = {
    padding: '8px 11px',
    fontSize: '20px'
};

const FeedInput = ({
    name,
    validators,
    intl,
    canInvit = false
}) => {
    const i18n = useMemo(() => formatMessages(intl), [intl]);
    const { required, feedNameLength, feedDescriptionLength } = validators;

    return (
        <>
            <Row gutter={25}>
                <Col span={18}>
                    <Field
                        name={`${name}.name`}
                        component={LabelInput}
                        placeholder={i18n.namePlaceholder}
                        validate={composeValidators(required, feedNameLength)}
                        label={i18n.labelGroupName}
                        autoFocus
                        size="large"
                        style={inputXLargeStyle}
                    />
                </Col>
                <Col span={6}>
                    <Field
                        label={i18n.labelColor}
                        name={`${name}.color`}
                        component={LabelColorPicker}
                    />
                </Col>
            </Row>
            <Field
                label={i18n.labelDescription}
                name={`${name}.description`}
                component={LabelInput}
                style={inputXLargeStyle}
                placeholder={i18n.descriptionPlaceholder}
                validate={composeValidators(required, feedDescriptionLength)}
            />

            {canInvit && (
                <Field
                    label={i18n.sendInvitations}
                    name={`${name}._members`}
                    component={LabelUserMultiSelect}
                    notFoundContent={i18n.multiSelectNoOptionsText}
                    placeholder={i18n.multiSelectPlaceholder}
                />
            )}
        </>
    );
}

FeedInput.propTypes = {
    intl: PropTypes.any.isRequired,
    name: PropTypes.string.isRequired,
    validators: PropTypes.object.isRequired,
    canInvit: PropTypes.bool,
};

export default memo(injectIntl(FeedInput));
